// extracted by mini-css-extract-plugin
export default {"wrap":"Ns-z","fullWidth":"Os-z","items":"Ps-z","featureCss":"Qs-z","disabled":"Rs-z","imgCss":"Ss-z"};